"use client";

import { c as _c } from "react/compiler-runtime";
import { ServiceProcessCard, ServiceProcessCardProps } from "@/components/common/service-process-card";
import dynamic from "next/dynamic";
const ConsultationProposalForm = dynamic(() => import("@/components/forms/consultation-proposal-form").then(mod => mod.ConsultationProposalForm), {
  ssr: false
});
import { Section } from "@/components/section";
import { Spinner } from "@/components/ui/spinner";
import { hasData } from "@/helpers/has-data";
import { Suspense } from "react";
type TrainingServiceProcessProps = {
  section: PageSections;
  data: {
    heading: string;
    seoHeading?: string;
    imagePath: string;
    imageAltText: string;
    description: string;
    actionButtonText: string;
    actionButtonUrl: string;
    cards: ServiceProcessCardProps[];
  };
};
const TrainingServiceProcess = t0 => {
  const $ = _c(17);
  const {
    data,
    section
  } = t0;
  if (!hasData(data)) {
    return null;
  }
  const {
    heading,
    seoHeading,
    description,
    actionButtonText,
    actionButtonUrl
  } = data;
  const t1 = `${section.sectionClass} relative overflow-hidden`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-6 flex shrink-0 items-center gap-2"><span className="bg-secondary h-0.5 w-6 rounded" /><span className="text-secondary-main text-xs font-bold tracking-wider uppercase">Our Process</span></div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== data.cards) {
    t3 = data?.cards?.map((item, index) => <ServiceProcessCard key={`training-service-process-card-${index}`} stepNumber={index + 1} isLast={index === (data?.cards?.length ?? 0) - 1} {...item} />);
    $[1] = data.cards;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <div className="col-span-12 flex h-fit flex-col md:col-span-4 md:h-full">{t2}<div className="flex flex-1 flex-col">{t3}</div></div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="col-span-12 h-full md:col-span-8"><Suspense fallback={<Spinner />}><ConsultationProposalForm /></Suspense></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <div className="relative z-10 grid grid-cols-12 gap-8">{t4}{t5}</div>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== actionButtonText || $[9] !== actionButtonUrl || $[10] !== description || $[11] !== heading || $[12] !== section.sectionId || $[13] !== seoHeading || $[14] !== t1 || $[15] !== t6) {
    t7 = <Section title={heading} seoTitle={seoHeading} paragraph={description} actionLabel={actionButtonText} path={actionButtonUrl} id={section.sectionId} className={t1}>{t6}</Section>;
    $[8] = actionButtonText;
    $[9] = actionButtonUrl;
    $[10] = description;
    $[11] = heading;
    $[12] = section.sectionId;
    $[13] = seoHeading;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default TrainingServiceProcess;